import React, { useRef, useState } from 'react'
import { useAsync } from 'react-use'
import ListOperation from '@components/CRUD/ListOperation'
import { Button, Descriptions, Typography, Table, message } from 'antd'
import { ReloadOutlined, PlusOutlined } from '@ant-design/icons'
import { ModalForm, SelectInput } from '@components/Form'
import { useParams } from 'react-router-dom'
import PageLayout from '@layouts/PageLayout'
import { useLocalization } from '@contexts/LocalizationContext'
import Fetch from '@components/CRUD/Fetch'
import { client } from '@utils/client'
import validationSchemaChecklist from './validationSchemaChecklist'

const { Text, Link } = Typography

const Show = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [type, setType] = useState(null)
  const [version, setVersion] = useState(null)
  const { t } = useLocalization()
  const fetchRef = useRef(null)
  const params = useParams()
  const formItemLayout = {
    labelAlign: 'left',
  }
  const optionsStatus = [
    {
      label: t('article.form.options.success'),
      value: 'successed',
    },
    {
      label: t('article.form.options.fail'),
      value: 'failed',
    },
    {
      label: t('article.form.options.notSure'),
      value: 'notSure',
    },
  ]
  const options = [
    {
      label: t('article.form.options.vaccine'),
      value: 'vaccine',
    },
    {
      label: t('article.form.options.healthCheck'),
      value: 'healthCheck',
    },
    {
      label: t('article.form.options.development'),
      value: 'development',
    },
  ]
  const columns = [
    {
      title: t('article.showScreen.column.type'),
      // dataIndex: 'checklistTitle',
      key: 'checklistTitle',
      render: function checklistTitle(record) {
        return (
          <p>
            {record.checklistTitle}{' '}
            <span style={{ color: '#c4c4c4' }}>({record.description})</span>
          </p>
        )
      },
    },
    {
      title: t('article.showScreen.column.status'),
      dataIndex: 'forStatus',
      key: 'forStatus',
      render: function Status(forStatus) {
        return (
          <Button
            type={forStatus === 'notSure' ? 'default' : 'primary'}
            danger={forStatus === 'failed' ? true : false}
            shape="round"
          >
            {forStatus}
          </Button>
        )
      },
    },
    {
      title: t('article.showScreen.column.version'),
      dataIndex: 'version',
      key: 'version',
      render: function Version(version) {
        return <p>v. {version}</p>
      },
    },
    {
      title: t('article.showScreen.column.action'),
      key: 'action',
      render: function Action(record) {
        return (
          <ListOperation
            row={record}
            isEdit={false}
            isView={false}
            deletePath={`/blog/${params.id}/checklistMaps/${record.checklistId}`}
            handleReload={handleReload}
          />
        )
      },
    },
  ]

  const handleReload = () => {
    fetchRef.current.reload()
  }

  const fetch = async () => {
    const result = await client
      .get(`/blog/${params.id}`)
      .then((res) => res.data)
    const checklistMaps = result.checklistMaps.map((v) => {
      return {
        checklistId: v.id,
        checklistTitle: v.checklist.title,
        version: v.checklist.version,
        forStatus: v.forStatus,
        description: v.checklist.description,
      }
    })
    console.log(checklistMaps)
    return { result, checklistMaps }
  }

  const state = useAsync(async () => {
    const versions = await client
      .get('/checklist/versions', {
        params: { type: type },
      })
      .then((res) => res.data)
    const result = versions.map((item) => item.version).sort((a, b) => b - a)
    if (result.length > 0) {
      setVersion(result[0])
    }
    return result
  }, [type])

  const stateChecklist = useAsync(async () => {
    const checklist = await client
      .get('/checklist', {
        params: {
          where: JSON.stringify({
            type,
            version,
          }),
          order: { from: 'ASC' },
        },
      })
      .then((res) => res.data)
    const result = checklist.data.map(({ title, id, description }) => {
      return { title, id, description }
    })
    return result
  }, [version])

  const showModal = () => {
    setIsModalVisible(true)
  }
  const hideModal = () => {
    setIsModalVisible(false)
  }
  const changeType = (v) => {
    setType(v)
  }

  const changeVersion = (v) => {
    setVersion(v)
  }

  const handleSubmit = async (v) => {
    try {
      await client
        .post(`/blog/${params.id}/checklistMaps`, {
          checklistId: v.checklistId,
          forStatus: v.forStatus,
        })
        .then((res) => res.data)
      message.success('สำเร็จ')
      hideModal()
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }
  console.log('q', stateChecklist)
  return (
    <Fetch fetch={fetch} ref={fetchRef}>
      {({ result, checklistMaps }) => (
        <PageLayout
          title={t('article.showScreen.title')}
          editPath={`/blogs/${params.id}/edit`}
          extra={[
            <Button
              key="reload"
              icon={<ReloadOutlined />}
              onClick={handleReload}
            >
              {t('hospital.showScreen.reload')}
            </Button>,
          ]}
        >
          <Descriptions column={1}>
            <Descriptions.Item
              label={<Text strong>{t('article.showScreen.label.title')}</Text>}
            >
              {result.title}
            </Descriptions.Item>
            <Descriptions.Item
              label={<Text strong>{t('article.showScreen.label.url')}</Text>}
            >
              <Link href={result.url} target="_blank">
                {result.url}
              </Link>
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <Text strong>{t('article.showScreen.label.checklist')}</Text>
              }
            >
              <Button
                key="reload"
                type="primary"
                icon={<PlusOutlined />}
                onClick={showModal}
              >
                {t('article.showScreen.addBtn')}
              </Button>
            </Descriptions.Item>
          </Descriptions>
          <Table
            rowKey="checklistId"
            columns={columns}
            dataSource={checklistMaps}
            // onChange={handleChange}
            // pagination={{
            //   defaultCurrent: defaultPageSize,
            //   defaultPageSize: defaultPageSize,
            //   current: page,
            //   pageSize,
            //   total,
            // }}
          ></Table>
          <ModalForm
            title={t('article.showScreen.modal.title')}
            visible={isModalVisible}
            validationSchema={validationSchemaChecklist(t)}
            onSubmit={handleSubmit}
            onCancel={hideModal}
          >
            <SelectInput
              name="type"
              label={t('article.form.label.checklist')}
              options={options}
              formItemOptions={{
                formItemLayout,
              }}
              onSelect={changeType}
              // mode="multiple"
              allowClear
            />
            <SelectInput
              name="version"
              value={version}
              label={t('article.form.label.version')}
              options={(state.value || []).map((item) => ({
                label: item,
                value: item,
              }))}
              formItemOptions={{
                formItemLayout,
              }}
              onSelect={changeVersion}
              // mode="multiple"
              allowClear
            />
            <SelectInput
              name="checklistId"
              label={t('article.form.label.checklist')}
              options={(stateChecklist.value || []).map((item) => ({
                label: item.title,
                value: item.id,
                desc: item.description,
              }))}
              formItemOptions={{
                formItemLayout,
              }}
              // mode="multiple"
              allowClear
            />
            <SelectInput
              name="forStatus"
              label={t('article.form.label.status')}
              options={optionsStatus}
              formItemOptions={{
                formItemLayout,
              }}
              // mode="multiple"
              allowClear
            />
          </ModalForm>
        </PageLayout>
      )}
    </Fetch>
  )
}

export default Show
